import { createStore } from 'satcheljs';
import { InsertLinksNotActive } from '../utils/constants';
import { LinkPluginViewStore } from './schema/LinkPluginViewStore';

const linkPluginViewStore: LinkPluginViewStore = {
    insertLinksTaskId: InsertLinksNotActive,
};

export const getStore = createStore<LinkPluginViewStore>(
    'linkPluginViewStore',
    linkPluginViewStore
);
